module.exports = require('./helpers/bundle-url').getBundleURL('UckoE') + "cooking.396baa5d.gif" + "?" + Date.now();